import React, { useEffect } from 'react';

import $ from 'jquery';
import classNames from 'classnames';

import { Icon } from '../Common';

interface TimelineProps {
  /** Timeline items to order in a timeline. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string;
  /** Headline for the timeline. */
  header?: React.ReactNode;
}

const Timeline = ({ children, className, header }: TimelineProps) => {
  // TODO: modify for a display when initially rendering.
  useEffect(() => {
    $(window).on('scroll', function () {
      $('.ce-timeline-item').each(function () {
        if (
          $(this).offset().top <=
            $(window).scrollTop() + $(window).height() * 0.75 &&
          $(this).find('.ce-timeline-icon').hasClass('is-hidden')
        ) {
          $(this)
            .find('.ce-timeline-icon, .ce-timeline-content')
            .removeClass('is-hidden')
            .addClass('bounce-in');
        }
      });
    });
  });

  return (
    <div className={classNames(className, 'ce ce-timeline')}>
      {header}
      <div className="ce-timeline-wrapper">
        {children}
        {/* Final Icon at the bottom of the Timeline */}
        <div className="ce-timeline-item gray">
          <div className="ce-timeline-icon bounce-in">
            <Icon name="fa-hourglass-start" />
          </div>
        </div>
      </div>
    </div>
  );
};

Timeline.defaultProps = {
  className: null,
  header: null,
};

export default Timeline;
